import { Typography } from '@/shared/components/atoms';

interface Props {
  title: string;
  message: string | React.ReactNode;
  icon: React.ReactNode;
}
const HomeWidgetEmptyState: React.FC<Props> = ({ message, title, icon }) => {
  return (
    <div className='my-auto flex w-full flex-col items-center justify-center'>
      <span className='text-primary-60'>{icon}</span>
      <Typography variant='subtitle' weight='bold' className='mb-4 mt-16'>
        {title}
      </Typography>
      {typeof message === 'string' ? (
        <Typography className='max-w-[50%] text-center text-surface-10'>
          {message}
        </Typography>
      ) : (
        message
      )}
    </div>
  );
};

export { HomeWidgetEmptyState };
